import React, { Component } from 'react'
import { Col, Container, FormGroup, Input, Label, Row } from 'reactstrap'
import Footer from '../../comum/components/Footer'
import FiltroCheckbox from '../components/FiltroVisualizacaoCheck'
import FiltroBtn from '../components/FiltroVisualizacaoBtn'
import CardPredefinicoes from '../components/CardPredefinicoes'
import ModalForm from "../components/ModalForm";

import { observer } from "mobx-react";
import FooterContent from './FooterContent';


/**
 * Para cada parametro de definição de algum objeto dentro deste componente
 * São passados objetos contendo os segunites valores
 * 
 * checkboxItems:
 *{
 * titulo:"", //Título da seção - String
 * itens:"", //Itens da coluna - String(Nome do observable)
 * itensAtivos:"", //Itens que estão ativos - String(Nome do observable)
 * itensRequeridos: "", //Itens que são marcardos como requeridos - String(Nome do observable)
 * onClickItem: "" //Função de click para os checkbox - String(Nome do observable)
 *}
 *
 * btnItems:
 *{
 *  titulo:"", //Título da seção - String
 *  itens:"", //Itens da coluna - String(Nome do observable)
 *  itensAtivos:"", //Itens que estão ativos - String(Nome do observable)
 *  onClickItem:"" //Função de click para os botões - String(Nome do observable)
 *}
 *
 *rowCardItems:
 *{
 *  titulo:"", //Título da seção - String
 *  container: "predefinicoes", // Container contendo as informações para o card - String(Nome do observable)
 *  ativo: "predefinicaoAtiva", // Informação do card ativo - Stting(Nome do observable)
 *  onClick: "predefinicaoClick", //Função de click para os cards - String(Nome do observable)
 *                                //Os cards podem ser editáveis então, a partir daqui teremos as opções de edição para cada card
 *  editarClick: "editarPredeficaoNomeClick" //
 *  editCancel:"cancelarNovoNome", //Função para cancelar a edição - String(Nome do observable)
 *  editSave: "salvarNovoNome", //Função para salvar a edição - String(Nome do observable)
 *  editLabels:[ //Array de objetos para os campos de edição do card - Array<Object1>
 *     {
 *        label:"Nome", //Label do campo de edição - String
 *        value:"nome", //Valor do campo - String
 *        onChange:"mudarNomePred" //Função para usar caso mude algum valor dentro do campo - String
 *      }
 *  ]
 *}
 * 
 * Além disso é necessário passar um controller para o objeto, aonde os nomes do items são referentes aos
 * encontrados dentros deste controller
 */

@observer
export default class JanelaFiltros extends Component {

    constructor(props){
        super(props)
        
        this.controller = this.props.controller
    }

    render() {
        return (
            <Container fluid>
                <div>
                    {this.props.editName && 
                        <ModalForm onClickCancelar={ this.controller[this.props.rowCardsItems.editCancel] } onClickSalvar={ this.controller[this.props.rowCardsItems.editSave] } >
                            <h2>Editar</h2>
                            <Row>
                                {this.props.rowCardsItems.editLabels.map((item, index) =>{
                                    const whatEdit = this.controller[this.props.rowCardsItems.container]
                                    const whichEdit = whatEdit[this.controller[this.props.rowCardsItems.ativo]]
                                    return (
                                        <Col sm={12} md={6} key={index}>
                                            <FormGroup>
                                                <Label>{item.label}</Label>
                                                <Input
                                                    value = {whichEdit[item.value]} 
                                                    onChange={(e) => this.controller[item.onChange](e)}
                                                />
                                            </FormGroup>
                                        </Col>
                                    )
                                })}
                            </Row>
                        </ModalForm>
                    }
                    {this.props.showWarningModal && this.props.warningModal}
                    {this.props.fields && 
                        this.props.fields.map((field,index) => {
                            switch(field){
                                case 'checkbox':
                                    return (
                                        <div key={index}>
                                            <FiltroCheckbox
                                                selecionarTudo={this.props.checkboxItems.selecionarTudo && this.controller[this.props.checkboxItems.selecionarTudo]}
                                                limparTudo={this.props.checkboxItems.limparTudo && this.controller[this.props.checkboxItems.limparTudo]} 
                                                titulo={this.props.checkboxItems ? this.props.checkboxItems.titulo : "Tabela"}
                                                itens={this.controller[this.props.checkboxItems.itens]}
                                                itensAtivos={this.controller[this.props.checkboxItems.itensAtivos]}
                                                itensRequeridos={this.controller[this.props.checkboxItems.itensRequeridos]} //TODO: implementar itens requeridos
                                                onClickItem={this.controller[this.props.checkboxItems.onClickItem]}
                                            />
                                        </div>
                                    )
                                case 'btn':
                                    return (
                                        <div key={index}>
                                            <FiltroBtn titulo={this.props.btnItems ? this.props.btnItems.titulo : "Botões"}
                                                       itens={this.controller[this.props.btnItems.itens]}
                                                       itensAtivos={this.controller[this.props.btnItems.itensAtivos]}
                                                       onClickItem={this.controller[this.props.btnItems.onClickItem]}
                                            />
                                        </div>
                                    )
                                case 'rowCards':
                                    return (
                                        <div key={index}>
                                            <h2>{this.props.rowCardsItems.titulo}</h2>
                                            <Row className="linha-filtro-predefinicoes">
                                                { this.controller[this.props.rowCardsItems.container] && this.controller[this.props.rowCardsItems.container].map((card, i) => (
                                                    <CardPredefinicoes valor={card.valor} key={i}
                                                                        nome={card.nome}
                                                                        descricao={card.descricao}
                                                                        index={i}
                                                                        ativo={ this.controller[this.props.rowCardsItems.ativo]===i }
                                                                        onClick={ this.controller[this.props.rowCardsItems.onClick] } 
                                                                        editarClick={ this.controller[this.props.rowCardsItems.editarClick] }/>
                                                )) }
                                            </Row>
                                        </div>
                                    )
                                default:
                                    return null
                            }
                        })
                    }
                    <div>
                        <Footer className="filtro-content-end rodape-filtro-predefinicoes">
                            <FooterContent>
                                <div className="justify-content-end align-self-center" >
                                    {this.props.cancelButAction && <Label className="btn-primary janelafiltro--footer__button" onClick={this.props.cancelButAction}>Cancelar</Label>}
                                    <Label className="btn-primary btn-aplicar" onClick={this.props.closeAction}>Aplicar</Label>
                                </div>
                            </FooterContent>
                        
                        </Footer>
                    </div>
                </div>
            </Container>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/JanelaFiltros.js